// 先読み専用の優先度付き実行キュー (2026-08-02)。
// 表示に必要な取得はこのキューを通さず即時 fetch される (従来どおり)。
// 先読みだけをここへ入れ、同時実行数を絞ることで、表示 FT を先読み圏外へ
// 跳んだときも表示用の取得が帯域を確保できるようにする。
// newGeneration() を呼ぶと未着手のジョブは全て破棄される (実行中の数本は流し切る)。
// enqueue した順に実行されるため、呼び出し側は「近い FT から」積むこと。
export class PrefetchQueue {
    private queue: { run: () => Promise<unknown>; generation: number }[] = [];
    private active = 0;
    private generation = 0;

    constructor(private readonly concurrency: number) {}

    newGeneration() {
        this.generation++;
        this.queue.length = 0;
    }

    enqueue(run: () => Promise<unknown>) {
        this.queue.push({ run, generation: this.generation });
        this.pump();
    }

    private pump() {
        while (this.active < this.concurrency && this.queue.length > 0) {
            const job = this.queue.shift()!;
            if (job.generation !== this.generation) {
                continue;
            }
            this.active++;
            job.run()
                .catch(() => undefined)
                .finally(() => {
                    this.active--;
                    this.pump();
                });
        }
    }
}
